/**
 * Created by Daniel Wang on 1/29/2024.
 * Description: clamav file lookup component
 * ------ maintenance history ------
 */

import { ColDef, GridApi, GridOptions } from 'ag-grid-community';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { of, Subscription } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { AdminPagesService } from '../../../../tamalelibs/services/admin-page.service';
import { ToastService } from '../../../../widgets/toast/toast.service';
import { UntypedFormControl } from '@angular/forms';
import { AdminPageActionsComponent } from '../../admin-page-actions/admin-page-actions.component';
import { adminPagesConstants } from '../../admin-page-setting.constants';
import { AdminPageFeedback, AdminPageFeedbackTypes, AdminPageSetting } from '../../admin-page-setting.model';
import { AlertWindowService } from '../../../../widgets/alert-window/alert-window.service';
import { StringLiteralsPipe } from '../../../../pipes/translate.pipe';
import { NotificationStyles } from '../../../../widgets/notification/notification.model';
import { DatePipe } from '@angular/common';

//#region mock data
export const mockdata = {
    'message': [
        'Ignored file: -------------------------------------------------------------------------------.',
        'Ignored file: WARNING: Only scanning files from --file-list (files passed at cmdline are ignored).',
        'Ignored file: ----------- SCAN SUMMARY -----------.',
        'Ignored file: Known viruses: 8681799.',
        'Ignored file: Engine version: 0.103.4.',
        'Ignored file: Scanned directories: 9.',
        'Ignored file: Scanned files: 18502.',
        'Ignored file: Infected files: 0.',
        'Ignored file: Data scanned: 1007.46 MB.',
        'Ignored file: Data read: 624.31 MB (ratio 1.61:1).',
        'Ignored file: Time: 547.114 sec (9 m 7 s).',
        'Ignored file: Start Date: 2024:01:14 05:00:03.',
        'Ignored file: End Date:   2024:01:14 05:09:10.',
        'Ignored file: -------------------------------------------------------------------------------.',
        'Ignored file: WARNING: Only scanning files from --file-list (files passed at cmdline are ignored).',
        'Ignored file: ----------- SCAN SUMMARY -----------.',
        'Ignored file: Known viruses: 8681898.',
        'Ignored file: Engine version: 0.103.4.',
        'Ignored file: Scanned directories: 9.',
        'Ignored file: Scanned files: 18424.',
        'Ignored file: Infected files: 1.',
        'Ignored file: Data scanned: 1053.12 MB.',
        'Ignored file: Data read: 547.66 MB (ratio 1.92:1).',
        'Ignored file: Time: 601.188 sec (10 m 1 s).',
        'Ignored file: Start Date: 2024:01:15 05:00:03.',
        'Ignored file: End Date:   2024:01:15 05:10:04.',
        'Ignored file: -------------------------------------------------------------------------------.',
        'Ignored file: WARNING: Only scanning files from --file-list (files passed at cmdline are ignored).',
        'Ignored file: ----------- SCAN SUMMARY -----------.',
        'Ignored file: Known viruses: 8682007.',
        'Ignored file: Engine version: 0.103.4.',
        'Ignored file: Scanned directories: 9.',
        'Ignored file: Scanned files: 18325.',
        'Ignored file: Infected files: 2.',
        'Ignored file: Data scanned: 877.26 MB.',
        'Ignored file: Data read: 547.37 MB (ratio 1.60:1).',
        'Ignored file: Time: 501.243 sec (8 m 21 s).',
        'Ignored file: Start Date: 2024:01:16 05:00:03.',
        'Ignored file: End Date:   2024:01:16 05:08:25.',
        'Ignored file: -------------------------------------------------------------------------------.',
        'Ignored file: WARNING: Only scanning files from --file-list (files passed at cmdline are ignored).',
        'Ignored file: ----------- SCAN SUMMARY -----------.',
        'Ignored file: Known viruses: 8682129.',
        'Ignored file: Engine version: 0.103.4.',
        'Ignored file: Scanned directories: 9.',
        'Ignored file: Scanned files: 18511.',
        'Ignored file: Infected files: 4.',
        'Ignored file: Data scanned: 693.81 MB.',
        'Ignored file: Data read: 735.77 MB (ratio 0.94:1).',
        'Ignored file: Time: 450.151 sec (7 m 30 s).',
        'Ignored file: Start Date: 2024:01:17 05:00:03.',
        'Ignored file: End Date:   2024:01:17 05:07:33.',
        'Ignored file: -------------------------------------------------------------------------------.',
        'Ignored file: WARNING: Only scanning files from --file-list (files passed at cmdline are ignored).',
        'Ignored file: ----------- SCAN SUMMARY -----------.',
        'Ignored file: Known viruses: 8682187.',
        'Ignored file: Engine version: 0.103.4.',
        'Ignored file: Scanned directories: 9.',
        'Ignored file: Scanned files: 18397.',
        'Ignored file: Infected files: 4.',
        'Ignored file: Data scanned: 938.90 MB.',
        'Ignored file: Data read: 583.77 MB (ratio 1.61:1).',
        'Ignored file: Time: 533.445 sec (8 m 53 s).',
        'Ignored file: Start Date: 2024:01:18 05:00:03.',
        'Ignored file: End Date:   2024:01:18 05:08:57.',
        'Ignored file: -------------------------------------------------------------------------------.',
        'Ignored file: WARNING: Only scanning files from --file-list (files passed at cmdline are ignored).',
        'Ignored file: ----------- SCAN SUMMARY -----------.',
        'Ignored file: Known viruses: 8682225.',
        'Ignored file: Engine version: 0.103.4.',
        'Ignored file: Scanned directories: 9.',
        'Ignored file: Scanned files: 18443.',
        'Ignored file: Infected files: 5.',
        'Ignored file: Data scanned: 709.03 MB.',
        'Ignored file: Data read: 652.47 MB (ratio 1.09:1).',
        'Ignored file: Time: 422.520 sec (7 m 2 s).',
        'Ignored file: Start Date: 2024:01:19 05:00:03.',
        'Ignored file: End Date:   2024:01:19 05:07:06.',
        'Ignored file: -------------------------------------------------------------------------------.',
        'Ignored file: WARNING: Only scanning files from --file-list (files passed at cmdline are ignored).',
        'Ignored file: ----------- SCAN SUMMARY -----------.',
        'Ignored file: Known viruses: 8682292.',
        'Ignored file: Engine version: 0.103.4.',
        'Ignored file: Scanned directories: 9.',
        'Ignored file: Scanned files: 18504.',
        'Ignored file: Infected files: 5.',
        'Ignored file: Data scanned: 661.55 MB.',
        'Ignored file: Data read: 548.40 MB (ratio 1.21:1).',
        'Ignored file: Time: 428.284 sec (7 m 8 s).',
        'Ignored file: Start Date: 2024:01:20 05:00:04.',
        'Ignored file: End Date:   2024:01:20 05:07:12.',
        'Files found.'
    ],
    'results': [
        {
            'fileName': 'EB114F98FC6F2EBBEF8894E4DA4C12A9',
            'entityName': 'ADVS_012',
            'entryFileID': '730a839bafca4b3db246e5e27787a895',
            'submittedDate': 1583374633753,
            'title': 'webFrontSheet.xlam'
        },
        {
            'fileName': 'F23876F4DE0308D3A8E60344B80F9840',
            'entityName': 'ADVS_012',
            'entryFileID': '596ba4b603e046dea36179d6c0cb97c8',
            'submittedDate': 1584604025174,
            'title': 'webFrontSheet-dev-latest.xlam'
        },
        {
            'fileName': 'EB114F98FC6F2EBBEF8894E4DA4C12A9',
            'entityName': 'ADVS_012',
            'entryFileID': '730a839bafca4b3db246e5e27787a895',
            'submittedDate': 1583374633753,
            'title': 'webFrontSheet.xlam'
        },
        {
            'fileName': 'FE6739E95F87165EB592AA8155DF1BF2',
            'entityName': 'ADVS_012',
            'entryFileID': 'a896d5d1f70d4953b3092303dd6c1419',
            'submittedDate': 1582193167215,
            'title': 'webFrontSheet.xlam'
        },
        {
            'fileName': 'FE6739E95F87165EB592AA8155DF1BF2',
            'entityName': 'ADVS_012',
            'entryFileID': 'a896d5d1f70d4953b3092303dd6c1419',
            'submittedDate': 1582253587867,
            'title': 'webFrontSheet.xlam'
        },
        {
            'fileName': 'FFF7931722A5534DE5503731FFCE0257',
            'entityName': 'ADVS_012',
            'entryFileID': '1d4a47b42ee44979aea93842af8ef56b',
            'submittedDate': 1584587115716,
            'title': 'webFrontSheet-dev-latest.xlam'
        },
        {
            'fileName': 'EB114F98FC6F2EBBEF8894E4DA4C12A9',
            'entityName': 'ADVS_012',
            'entryFileID': '730a839bafca4b3db246e5e27787a895',
            'submittedDate': 1583374633753,
            'title': 'webFrontSheet.xlam'
        },
        {
            'fileName': 'F23876F4DE0308D3A8E60344B80F9840',
            'entityName': 'ADVS_012',
            'entryFileID': '596ba4b603e046dea36179d6c0cb97c8',
            'submittedDate': 1584604025174,
            'title': 'webFrontSheet-dev-latest.xlam'
        },
        {
            'fileName': 'F23876F4DE0308D3A8E60344B80F9840',
            'entityName': 'ADVS_012',
            'entryFileID': '596ba4b603e046dea36179d6c0cb97c8',
            'submittedDate': 1584604025174,
            'title': 'webFrontSheet-dev-latest.xlam'
        },
        {
            'fileName': 'EB114F98FC6F2EBBEF8894E4DA4C12A9',
            'entityName': 'ADVS_012',
            'entryFileID': '730a839bafca4b3db246e5e27787a895',
            'submittedDate': 1583374633753,
            'title': 'webFrontSheet.xlam'
        },
        {
            'fileName': 'FFF7931722A5534DE5503731FFCE0257',
            'entityName': 'ADVS_012',
            'entryFileID': '1d4a47b42ee44979aea93842af8ef56b',
            'submittedDate': 1584587115716,
            'title': 'webFrontSheet-dev-latest.xlam'
        },
        {
            'fileName': 'FE6739E95F87165EB592AA8155DF1BF2',
            'entityName': 'ADVS_012',
            'entryFileID': 'a896d5d1f70d4953b3092303dd6c1419',
            'submittedDate': 1582193167215,
            'title': 'webFrontSheet.xlam'
        },
        {
            'fileName': 'FE6739E95F87165EB592AA8155DF1BF2',
            'entityName': 'ADVS_012',
            'entryFileID': 'a896d5d1f70d4953b3092303dd6c1419',
            'submittedDate': 1582253587867,
            'title': 'webFrontSheet.xlam'
        },
        {
            'fileName': '0B8330AA23E10FE7F88B3AD6097F150B',
            'entityName': 'ADVS_012',
            'entryFileID': 'ef553c45a4014b64872b5737f3c2ed90',
            'submittedDate': 1583921640322,
            'title': 'Front Sheet Demo.7z'
        },
        {
            'fileName': '0B8330AA23E10FE7F88B3AD6097F150B',
            'entityName': 'ADVS_012',
            'entryFileID': 'ef553c45a4014b64872b5737f3c2ed90',
            'submittedDate': 1583922859686,
            'title': 'Front Sheet Demo.7z'
        },
        {
            'fileName': '0B8330AA23E10FE7F88B3AD6097F150B',
            'entityName': 'ADVS_012',
            'entryFileID': 'ef553c45a4014b64872b5737f3c2ed90',
            'submittedDate': 1583921868467,
            'title': 'Front Sheet Demo.7z'
        },
        {
            'fileName': '0B8330AA23E10FE7F88B3AD6097F150B',
            'entityName': 'ADVS_012',
            'entryFileID': 'ef553c45a4014b64872b5737f3c2ed90',
            'submittedDate': 1583845570912,
            'title': 'Front Sheet Demo.7z'
        },
        {
            'fileName': '0B8330AA23E10FE7F88B3AD6097F150B',
            'entityName': 'ADVS_012',
            'entryFileID': 'ef553c45a4014b64872b5737f3c2ed90',
            'submittedDate': 1583917302834,
            'title': 'Front Sheet Demo.7z'
        },
        {
            'fileName': 'FE6739E95F87165EB592AA8155DF1BF2',
            'entityName': 'ADVS_012',
            'entryFileID': 'a896d5d1f70d4953b3092303dd6c1419',
            'submittedDate': 1582193167215,
            'title': 'webFrontSheet.xlam'
        },
        {
            'fileName': 'FE6739E95F87165EB592AA8155DF1BF2',
            'entityName': 'ADVS_012',
            'entryFileID': 'a896d5d1f70d4953b3092303dd6c1419',
            'submittedDate': 1582253587867,
            'title': 'webFrontSheet.xlam'
        },
        {
            'fileName': 'FFF7931722A5534DE5503731FFCE0257',
            'entityName': 'ADVS_012',
            'entryFileID': '1d4a47b42ee44979aea93842af8ef56b',
            'submittedDate': 1584587115716,
            'title': 'webFrontSheet-dev-latest.xlam'
        },
        {
            'fileName': 'EB114F98FC6F2EBBEF8894E4DA4C12A9',
            'entityName': 'ADVS_012',
            'entryFileID': '730a839bafca4b3db246e5e27787a895',
            'submittedDate': 1583374633753,
            'title': 'webFrontSheet.xlam'
        },
        {
            'fileName': 'F23876F4DE0308D3A8E60344B80F9840',
            'entityName': 'ADVS_012',
            'entryFileID': '596ba4b603e046dea36179d6c0cb97c8',
            'submittedDate': 1584604025174,
            'title': 'webFrontSheet-dev-latest.xlam'
        },
        {
            'fileName': 'F23876F4DE0308D3A8E60344B80F9840',
            'entityName': 'ADVS_012',
            'entryFileID': '596ba4b603e046dea36179d6c0cb97c8',
            'submittedDate': 1584604025174,
            'title': 'webFrontSheet-dev-latest.xlam'
        },
        {
            'fileName': 'EB114F98FC6F2EBBEF8894E4DA4C12A9',
            'entityName': 'ADVS_012',
            'entryFileID': '730a839bafca4b3db246e5e27787a895',
            'submittedDate': 1583374633753,
            'title': 'webFrontSheet.xlam'
        },
        {
            'fileName': 'FFF7931722A5534DE5503731FFCE0257',
            'entityName': 'ADVS_012',
            'entryFileID': '1d4a47b42ee44979aea93842af8ef56b',
            'submittedDate': 1584587115716,
            'title': 'webFrontSheet-dev-latest.xlam'
        },
        {
            'fileName': 'FE6739E95F87165EB592AA8155DF1BF2',
            'entityName': 'ADVS_012',
            'entryFileID': 'a896d5d1f70d4953b3092303dd6c1419',
            'submittedDate': 1582193167215,
            'title': 'webFrontSheet.xlam'
        },
        {
            'fileName': 'FE6739E95F87165EB592AA8155DF1BF2',
            'entityName': 'ADVS_012',
            'entryFileID': 'a896d5d1f70d4953b3092303dd6c1419',
            'submittedDate': 1582253587867,
            'title': 'webFrontSheet.xlam'
        },
        {
            'fileName': '0B8330AA23E10FE7F88B3AD6097F150B',
            'entityName': 'ADVS_012',
            'entryFileID': 'ef553c45a4014b64872b5737f3c2ed90',
            'submittedDate': 1583921640322,
            'title': 'Front Sheet Demo.7z'
        },
        {
            'fileName': '0B8330AA23E10FE7F88B3AD6097F150B',
            'entityName': 'ADVS_012',
            'entryFileID': 'ef553c45a4014b64872b5737f3c2ed90',
            'submittedDate': 1583922859686,
            'title': 'Front Sheet Demo.7z'
        },
        {
            'fileName': '0B8330AA23E10FE7F88B3AD6097F150B',
            'entityName': 'ADVS_012',
            'entryFileID': 'ef553c45a4014b64872b5737f3c2ed90',
            'submittedDate': 1583921868467,
            'title': 'Front Sheet Demo.7z'
        },
        {
            'fileName': '0B8330AA23E10FE7F88B3AD6097F150B',
            'entityName': 'ADVS_012',
            'entryFileID': 'ef553c45a4014b64872b5737f3c2ed90',
            'submittedDate': 1583845570912,
            'title': 'Front Sheet Demo.7z'
        },
        {
            'fileName': '0B8330AA23E10FE7F88B3AD6097F150B',
            'entityName': 'ADVS_012',
            'entryFileID': 'ef553c45a4014b64872b5737f3c2ed90',
            'submittedDate': 1583917302834,
            'title': 'Front Sheet Demo.7z'
        }
    ]
};
//#endregion

@Component({
    selector: 'tam-clamav-file-lookup',
    templateUrl: './clamav-file-lookup.component.html',
    styleUrls: ['./clamav-file-lookup.component.scss']
})
export class ClamAVFileLookupComponent implements OnInit, OnDestroy {
    // #region public properties
    columnDefs: Array<ColDef>;
    filename = '/var/log/clamav/clamscan.log';
    gridOptions: GridOptions;
    isShowFileMessage = false;
    isShowFileDetail = false;
    messages = [];
    name = new UntypedFormControl('');
    noDataStyle = 'none';
    reloading = false;
    rowData: Array<any> = [];
    // #endregion

    // #region private properties
    private _clamAVFileLookupPage: AdminPageSetting;
    private _destroySubscriptions: Array<Subscription> = [];
    private _gridApi: GridApi;
    // #endregion

    // #region constructor
    constructor(
        private _adminPagesServcie: AdminPagesService,
        private _alert: AlertWindowService,
        private _datepipe: DatePipe,
        private _toast: ToastService,
    ) {
    }
    // #endregion

    // #region angular functions
    ngOnInit() {
        this._initAGGridProperties();
        this._initAGGridColumns();
        this._clamAVFileLookupPage = adminPagesConstants['clamav-file-lookup'];
        this._destroySubscriptions.push(this._clamAVFileLookupPage.feedbackSubject$.subscribe(feedback => this._handleGridFeedback(feedback)));
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }
    // #endregion

    // #region public functions
    onGridReady(params) {
        this._gridApi = params.api;
        this._gridApi.sizeColumnsToFit();
    }

    onSubmit(event) {
        this.name.setErrors(null);

        if (!this.name.value) {
            this.name.setErrors({
                required: true
            });
        } else {
            this._adminPagesServcie.getClamAVFile(this.filename).pipe(
                take(1),
                catchError((error) => {
                    this._toast.notify({
                        style: NotificationStyles.Error,
                        message: error
                    });
                    return of(null);
                })
            ).subscribe(res => {
                this._handleResponse(res);
            });
        }
    }
    // #endregion

    // #region private functions
    private _handleDelete(feedback: AdminPageFeedback) {
        this._alert.warn(StringLiteralsPipe.translate('general.delete_confirmation_required'), [StringLiteralsPipe.translate('general.sure_want_to_delete_this_file')], 'Delete', 'Cancel').pipe(
            take(1)
        ).subscribe(confirmation => {
            if (confirmation) {
                const fileId = feedback.payload.data.entryFileID;
                this._adminPagesServcie.deleteClamAVFile(this.filename, fileId).pipe(
                    take(1),
                    catchError((error) => {
                        this._toast.notify({
                            style: NotificationStyles.Error,
                            message: error
                        });
                        return of(null);
                    })
                ).subscribe(res => {
                    this._handleResponse(res);
                });
            }
        });
    }

    private _handleGridFeedback(feedback: AdminPageFeedback) {
        switch (feedback.type) {
            case AdminPageFeedbackTypes.DELETE:
                this._handleDelete(feedback);
                break;
            default:
                break;
        }
    }

    private _handleResponse(res) {
        if (res) {
            if (res['message'] && res['message'].length > 0) {
                this.isShowFileMessage = true;
                this.messages = res['message'];
            }
            if (res['results'] && res['results'].length > 0) {
                this.isShowFileDetail = true;
                this.rowData = res['results'];
                this.rowData.forEach(item => {
                    item['editable'] = false;
                });
            } else {
                this.isShowFileDetail = false;
                this.rowData = [];
            }
        }
    }

    private _initAGGridColumns() {
        this.columnDefs = [{
            headerName: 'Filename',
            field: 'fileName',
            colId: 'fileName',
            menuTabs: []
        }, {
            headerName: 'Entity name',
            field: 'entityName',
            colId: 'entityName',
            menuTabs: []
        }, {
            headerName: 'Entry file ID',
            field: 'entryFileID',
            colId: 'entryFileID',
            menuTabs: []
        }, {
            headerName: 'Submitted date',
            field: 'submittedDate',
            colId: 'submittedDate',
            menuTabs: [],
            cellRenderer: (data) => {
                return this._datepipe.transform(new Date(data.value), 'MM/dd/yyyy HH:mm');
            }
        }, {
            headerName: 'Submitter',
            field: 'submitter',
            colId: 'submitter',
            menuTabs: []
        }, {
            headerName: 'Title',
            field: 'title',
            colId: 'title',
            menuTabs: []
        }, {
            headerName: 'Delete',
            colId: 'delete',
            minWidth: 96,
            width: 96,
            maxWidth: 96,
            cellRenderer: AdminPageActionsComponent,
            cellRendererParams: { feedbackSubject$: () => adminPagesConstants['clamav-file-lookup'].feedbackSubject$ },
            menuTabs: [],
            cellStyle: { 'text-align': 'center' },
        }];
    }

    private _initAGGridProperties() {
        this.gridOptions = {
            defaultColDef: {
                sortable: true,
                resizable: true,
                menuTabs: []
            },
            cacheBlockSize: 50,
            suppressCellFocus: true,
            suppressColumnVirtualisation: true,
            enableBrowserTooltips: true,
            rowSelection: 'single',
            sortingOrder: ['desc', 'asc'],
            maintainColumnOrder: true,
            suppressContextMenu: true,
            suppressDragLeaveHidesColumns: true,
            suppressRowGroupHidesColumns:true,
        };
    }
    // #endregion
}
